import React from 'react'

export type AssetType = 'animation' | 'static' | 'random'

export interface IAssetData {
	type: AssetType
	path: string
	width?: number
	height?: number
	config?: IConfig
}

export interface IRandomAssetData {
	type: AssetType
	randomId: string
	options: IAssetData[]
}

export enum FreezePosition {
	FirstSegmentStart = 'FirstSegmentStart',
	FirstSegmentEnd = 'FirstSegmentEnd',
	LastSegmentStart = 'LastSegmentStart',
	LastSegmentEnd = 'LastSegmentEnd',
}

export interface IConfig {
	assetsPath?: string
	autoplay?: boolean
	loop?: boolean
	segmentsData?: ISegmentsData
	style?: React.CSSProperties
}

export interface ISegmentsData {
	force: boolean
	segments: number[]
}

export const assetTypes = {
	ANIMATION: 'animation',
	RANDOM: 'random',
	STATIC: 'static',
}
